<template>
<div class="chapter">
<div class="inner_page">
<section>
<h2><span class="h2-inner">Chapter 3</span></h2>
<p class="firstInSection">Lara Panassai was thinking those unhappy thoughts again. She turned the shower on full blast, hoping the water would wash them away. A feeling of despair. She’d woken to the same dull ache in her stomach again. But she didn’t understand why. It wasn’t as if she was alone, she had someone to look after her – Matthew. That was the main thing, wasn’t it?</p>
<p>A knock on the bathroom door startled her. He was up.</p>
<p>‘Can I come in?’</p>
<p>‘Hang on. Won’t be a minute.’</p>
<p>He ignored her and invaded the room. ‘Everything OK, Lara?’</p>
<p>‘Yes, fine,’ she lied.</p>
<p>The shower door began to steam up, partially saving her blushes.</p>
<p>His eyes gorged on the view. Lara’s obvious discomfort made it all the more pleasurable. Pure lust. It was like he owned her. That was the best thing about having a lover like Lara. Thirty years his junior. He had all of her.</p>
<p>His toy.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter6.vue?fed2e0a2